module.exports = __webpack_public_path__ + "media/abk/assets/images/student_dashboard_bg-8138cc73047e4b51d603df6e267fed9d.jpg";